<!-- MODAL seleccionarProducto -->
<div mdbModal #seleccionarProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document" style="max-width: 50%;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar producto
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="Close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">

        <form [formGroup]='formHeader' novalidate>

        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="CodeProduct" class="form-control" formControlName="codeProduct" placeholder="Código"
                required #CodeProduct />
              <label for="CodeProduct">Código</label>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="descProduct" class="form-control" formControlName="descProduct" placeholder="Descripción"
                required #descProduct />
              <label for="descCodeProduct">Descripción</label>
            </div>
          </div>
        </div>


        <div class="row justify-content-between" style="border-top: 1px solid #dee2e6;">
          <div></div>
          <button class="btn btn-sm" mdbBtn type="button" color="info" mdbWavesEffect (click)="Buscar(1)">
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
          </button>
        </div>
        </form>
        <table class="table table-striped table-hover table-sm align-middle mt-1" *ngIf="showTable === true" >
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Descripción</th>
              <th scope="col">Detalle</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loadSpinner === true">
              <td colspan="100%" style="text-align: center">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
              </td>
            </tr>
            <tr *ngIf="!loading && Productos_lista?.length === 0">
              <td colspan="100%" style="text-align: center">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let pdt of Productos_lista">
              <td>{{pdt.producto_proveedor}}</td>
              <td>{{pdt.producto_descripcion}}</td>
              <td>{{pdt.detalle_producto}}</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                (click)="selectData(pdt)">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
          <app-pagination [context]="Product_paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="Productos_lista?.length > 0"></app-pagination>
        </table>
      </div>
    </div>
  </div>
</div>
